import { Transition } from "@headlessui/react"
import { Fragment, useEffect, useState } from "react"

export const SmoothTransition: React.FC<{className?: string, children: any}> = ({children, className}) => {
    const [isShowing, setIsShowing] = useState(false)
    useEffect(()=>{
        setIsShowing(true)
        return () => {
            setIsShowing(false)
        }
    },[])
    return (
        <Transition
          as={'div'}
          className={className}
          show={isShowing}
          enter="transform transition duration-[500ms]"
          enterFrom="opacity-0 -translate-y-2"
          enterTo="opacity-100 -translate-y-0"
          leave="transform duration-200 transition ease-in-out"
          leaveFrom="opacity-100 -translate-y-0"
          leaveTo="opacity-0 -translate-y-2"
        >
            {/* <div className="-translate-y-1/2">

            </div> */}
          {children}
        </Transition>
    )
}

export const SmoothLRTransition: React.FC<{className?: string, children: any}> = ({children, className}) => {
    const [isShowing, setIsShowing] = useState(false)
    useEffect(()=>{
        setIsShowing(true)
        return () => {
            setIsShowing(false)
        }
    },[])
    return (
        <Transition
          as={'div'}
          className={className}
          show={isShowing}
          enter="transform transition duration-[500ms]"
          enterFrom="opacity-0 -translate-x-2"
          enterTo="opacity-100 -translate-x-0"
          leave="transform duration-200 transition ease-in-out"
          leaveFrom="opacity-100 -translate-x-0"
          leaveTo="opacity-0 -translate-x-2"
        >
          {children}
        </Transition>
    )
}